module.exports = "/images/tnc.jpg?2a9129fa691e2073a38c6d69feddd4a5";